import React, { useContext } from 'react';

import UIStore from './UIStore';
import WidgetStore from "./WidgetStore";
import CreateWidgetStore from "./CreateWidgetStore";
import NiveauxIndicateurStore from "./NiveauxIndicateurStore";
import SidebarWidgetStore from "./SidebarWidgetStore";
import ConsignesStore from "./Widgets/ConsignesStore";
import MessagesInterServicesStore from "./Widgets/MessagesInterServicesStore";
import IndicateusStore from "./Widgets/IndicateusStore";
import PlanningActionsStore from "./Widgets/PlanningActionsStore";
import ParametresSystemeStore from "./Widgets/ParametresSystemeStore";
import BibliothequeImageStore from "./Widgets/BibliothequeImageStore";
import LoginStore from "./LoginStore";
import TableauBlancStore from "./Widgets/TableauBlancStore";
import WorkspaceStore from "./WorkspaceStore";
import RspStore from "./Widgets/RspStore";

const contextValue = {
    uiStore: new UIStore(),
    loginStore: new LoginStore(),
    widgetStore: new WidgetStore(),
    createWidgetStore : new CreateWidgetStore(),
    niveauxIndicateurStore : new NiveauxIndicateurStore(),
    sidebarWidgetStore : new SidebarWidgetStore(),
    consignesStore : new ConsignesStore(),
    indicateursStore : new IndicateusStore(),
    messageInterServicesStore : new MessagesInterServicesStore(),
    PlanningActionsStore : new PlanningActionsStore(),
    TableauBlancStore : new TableauBlancStore(),
    parametresStore : new ParametresSystemeStore(),
    bibliothequeImagesStore : new BibliothequeImageStore(),
    workspaceStore : new WorkspaceStore(),
    RspStore : new RspStore(),
};

export const AppContext = React.createContext(contextValue);

export const useStores = () => useContext(AppContext);
